if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');


      // Set up for A/B test
      this.runABtestFunction();
      document.addEventListener('rebuy:smartcart.hide', () => {
        // Set up for A/B test
        this.runABtestFunction();
      });
    }


    runABtestFunction() {
      if (document.querySelector('body').dataset['abProduct'] === 'true') {
        console.log('Running AB test');

        this.qty_fields = document.querySelectorAll('[update_form_qty]');
        this.atc_btns = document.querySelectorAll('.product-form__buttons button');

        const $this = this;
        fetch('/cart.js').then(cart => cart.json())
          .then(cart => {
            const items = cart.items;
            const product_handle = window.location.pathname.split('/').slice(-1)[0];
            const restricted_amount = parseInt(document.querySelector('.quantity-message').innerText.replace(/[^\d.]/g, ''));
            let found_product = false;
            items.forEach(item => {
              if (item.handle === product_handle) {
                found_product = true;
                if (item.quantity >= restricted_amount) {
                  $this.disableEverything();
                } else {
                  $this.enableEverythingThenRestrict(restricted_amount - item.quantity);
                }
              }
            });
            if (!found_product) {
              $this.enableEverything();
            }
          });
      }
    }
    disableEverything() {
      document.querySelector('.quantity-message').style.color = 'red';
      this.qty_fields.forEach(qty_field => {
        qty_field.disabled = true;
      });
      this.atc_btns.forEach(atc_btn => {
        atc_btn.disabled = true;
      });
    }
    enableEverything() {
      document.querySelector('.quantity-message').style.color = 'black';
      this.qty_fields.forEach(qty_field => {
        qty_field.disabled = false;
      });
      this.atc_btns.forEach(atc_btn => {
        atc_btn.disabled = false;
      });
      this.restrictQTY(parseInt(document.querySelector('.quantity-message').innerText.replace(/[^\d.]/g, '')));
    }
    enableEverythingThenRestrict(max_to_show) {
      document.querySelector('.quantity-message').style.color = 'black';
      this.qty_fields.forEach(qty_field => {
        qty_field.disabled = false;
      });
      this.atc_btns.forEach(atc_btn => {
        atc_btn.disabled = false;
      });
      this.restrictQTY(max_to_show);
    }
    restrictQTY(max_to_show) {
      let available_options = '';
      for (let i = 1; i <= max_to_show; i++) {
        available_options += `<option value="${i}">${i}</option>`;
      }
      this.qty_fields.forEach(qty_field => {
        qty_field.innerHTML = available_options;
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      document.addEventListener('finish:cart-request', () => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');

        // Set up for A/B test
        this.runABtestFunction();
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
